import React from "react";

import Table from "./Table";

import EnterpriseMembersContext from "../../../contexts/EnterpriseMembersContext";
import TeamContext from "../../../contexts/TeamContext";
import InviteMembersContext from "../../../contexts/InviteMembersContext";

export default function Index({ enterpriseId, teamId }) {
  return (
    <EnterpriseMembersContext enterpriseId={enterpriseId} teamId={teamId}>
      <TeamContext enterpriseId={enterpriseId}>
        <InviteMembersContext enterpriseId={enterpriseId}>
          <Table />
        </InviteMembersContext>
      </TeamContext>
    </EnterpriseMembersContext>
  );
}
